import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Spinner, request, toaster } from 'cademy-shared-web';
import { CourseViewer } from '../../components';
import Bugsnag from '@bugsnag/js';

const Booking = ({ subdomain }) => {
    const { booking_param } = useParams();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    useEffect(() => {
        request
            .get(`/get-course-lessons/booking/${booking_param}`)
            .then(({ data }) => {
                setData(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                if (
                    process.env.REACT_APP_ENVIRONMENT === 'Production' ||
                    process.env.REACT_APP_ENVIRONMENT === 'Stage'
                ) {
                    Bugsnag.notify(error);
                }
                toaster.danger('There was an issue loading the booking');
                window.location.href = '/profile';
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) return <Spinner />;

    return <CourseViewer data={data} setData={setData} />;
};

export default Booking;
